import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["bar"]

  connect() {
    this.onScroll = () => {
      if (this.scrollFrame) return
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null
        this.update()
      })
    }
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
    if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame)
    this.scrollFrame = null
  }

  update() {
    const doc = document.documentElement
    const scrollable = doc.scrollHeight - doc.clientHeight
    const progress = scrollable > 0 ? Math.min(1, Math.max(0, window.scrollY / scrollable)) : 0
    this.barTarget.style.transform = `scaleX(${progress})`
  }
}
